import { accessToken } from 'src/store/state';
// import { log } from 'src/log';

const url = 'https://jornada.soluzion.com.br/api/';

let fetching: null | Promise<Response> = null;

export const rpc = async <P, D>(
  method: string,
  params: P,
  logOnFail = true
): Promise<D> => {
  if (fetching !== null) await fetching;
  fetching = fetch(url, {
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken.value || ''}`,
    },
    method: 'post',
    body: JSON.stringify({ method, params }),
  }).finally(() => {
    fetching = null;
  });
  const response = await fetching;
  let r;
  try {
    r = (await response.json()) as { error?: string; data?: D };
  } catch (err) {
    if (logOnFail) {
      console.error(err);
      // log({
      //   category: 'exception',
      //   action: 'rpc',
      //   value: (err as Error).message,
      // });
    }
    throw new Error('Responsta inválida');
  }
  if (r.error) {
    if (logOnFail) {
      // log({
      //   category: 'exception',
      //   action: 'rpc',
      //   value: r.error,
      // });
    }
    if (r.error === 'Login obrigatório') {
      location.href = '/#/refresh-login';
    }
    throw new Error(r.error);
  } else if (r.data) {
    return r.data;
  } else {
    if (logOnFail) {
      // log({
      //   category: 'exception',
      //   action: 'rpc',
      //   value: 'Resposta sem dados',
      // });
    }
    throw new Error('Resposta sem dados');
  }
};
